import CampaignFooterInfluenceSummary from './CampaignFooterInfluenceSummary';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const useCampaignCardFooterAction = args => {
  const {
    fromObjectId,
    fromObjectTypeId
  } = args;
  if (fromObjectTypeId !== CONTACT_TYPE_ID) {
    return {
      primaryActionConfig: null
    };
  }
  return {
    primaryActionConfig: {
      label: /*#__PURE__*/_jsx(CampaignFooterInfluenceSummary, {
        contactId: fromObjectId
      })
    }
  };
};
export default useCampaignCardFooterAction;